import React, { createContext, useContext } from "react";
import type { GetLayoutFontFaces } from "../display-editor/DataProviderContext.js";

const CompiledLayoutFontFacesCtx = createContext<
  GetLayoutFontFaces | undefined
>(undefined);

/**
 * Returns the custom font loader registered for the compiled layout renderer tree.
 */
export function useCompiledLayoutFontFaces(): GetLayoutFontFaces | undefined {
  return useContext(CompiledLayoutFontFacesCtx);
}

type CompiledLayoutFontFacesProviderProps = {
  getLayoutFontFaces?: GetLayoutFontFaces;
  children: React.ReactNode;
};

/**
 * Supplies an optional font-face loader to {@link CompiledLayoutRenderer} descendants.
 */
export function CompiledLayoutFontFacesProvider({
  getLayoutFontFaces,
  children,
}: CompiledLayoutFontFacesProviderProps) {
  return (
    <CompiledLayoutFontFacesCtx.Provider value={getLayoutFontFaces}>
      {children}
    </CompiledLayoutFontFacesCtx.Provider>
  );
}
